import { Alert, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SignInForm from '@/components/forms/SignInForm';
import AuthHeader from '@/components/AuthHeader';
import useAuthStore from '@/store/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPath } from '@/utils';
import { Routes } from '@/constants/routes';

const SignInView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const sessionExpired = (location.state as { sessionExpired?: boolean })?.sessionExpired;

  const { signIn, error, clearError } = useAuthStore();

  const navigate = useNavigate();

  const handleForgetPassword = () => {
    navigate(getPath('..', Routes.ForgotPassword));
  };

  return (
    <Stack gap={8}>
      {sessionExpired && (
        <Alert severity="warning" sx={{ borderRadius: '8px' }}>
          {t('common:inactivity.sessionExpired')}
        </Alert>
      )}
      <AuthHeader
        title={t('auth:signIn.title')}
        subtitle={t('auth:signIn.subtitle')}
      />
      <SignInForm
        onSubmit={signIn}
        // @todo(KAN-16): implement all errors translation list
        error={!!error && t(`errors:custom.invalidCredentials`)}
        onForgotPasswordClick={handleForgetPassword}
        onResetError={clearError}
      />
    </Stack>
  );
};

export default SignInView;
